
import { Association } from "@/models";

export const formatAssociationAddress = (association: Association): string => {
  const parts = [];
  
  if (association.default_property_address) {
    parts.push(association.default_property_address);
  }
  
  if (association.default_property_city) {
    parts.push(association.default_property_city);
  }
  
  if (association.default_property_state) {
    parts.push(association.default_property_state);
  }
  
  if (association.default_property_zip) {
    parts.push(association.default_property_zip);
  }
  
  return parts.length > 0 ? parts.join(', ') : 'No address provided';
};

export const formatCurrency = (value: number | string): string => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(numValue);
};
